// // 群组 个人云文件选择器 //
<style lang="stylus">
    .fileSelected-container
        //position fixed
        //top 50%
        //left 50%
        //transform translate(-50%, -50%)
        //width 900px
        //height 546px
        //background #ffffff
        //border-radius 2px
        .mask-content
            display flex
            flex-wrap wrap
            height 453px
            box-sizing border-box
            &.mask-content-symbol
                height 493px
            .storage-box
                flex 0 0 260px
                border-right 1px solid #e6e8ea
                padding-top 15px

                .storage-item
                    display flex
                    align-items center
                    height 60px
                    cursor default

                    &.selected
                        background #f2f3f5

                    .img
                        flex 0 0 120px
                        display flex
                        align-items center
                        justify-content center

            .files-box
                flex 1 1 auto
                width 100%

                .folder-path-box
                    display flex
                    height 40px
                    align-items center

                    //.folder-path-action
                    //flex 0 0 40px
                    //display flex
                    //align-items center
                    //justify-content center
                    .folder-path
                        height 32px
                        line-height 32px
                        display flex
                        align-items center
                        border 1px solid #e8e8e8
                        padding 0 10px
                        box-sizing border-box
                        width 590px
                        border-radius 3px
                        color #222

                .files-list
                    //padding-left 40px
                    //padding-right 10px
                    cursor default
                    user-select none
                    height 413px
                    overflow auto
                    &::-webkit-scrollbar
                        width 8px
                        pointer-events none
                        background none
                    &::-webkit-scrollbar-thumb
                        background #00000026
                        border-radius 4px
                        border 1px solid #fff
                    &::-webkit-scrollbar-track
                        background #fff
                    &::-webkit-scrollbar-track-piece
                        background none
                    &::-webkit-scrollbar-corner
                        background none

                    .file-item
                        display flex
                        flex 1 1 100%
                        align-items center
                        height 46px
                        padding-left 8px

                        &:hover
                            background rgba(242, 244, 249, 0.60)

                        &.selected
                            background #F2F4F9;

                        .icon
                            flex 0 0 36px
                            text-align center
                            .folderIcon
                                width 20px
                                height 20px
                                fill #424242
                                stroke #424242
                            .fileIcon
                                width 22px
                                height 28px
                            .multiDrag-svg
                                width 24px
                                height 29px
                        .name
                            flex 1 0 100px
                            overflow hidden
                            white-space nowrap
                            text-overflow ellipsis
                            color #222

                        .time
                            flex 0 0 200px
                            color #222

                        .size
                            flex 0 0 60px
                            color #222

        .mask-bottom
            height 60px
            border-top 1px solid #e6e8ea
            padding 15px 0
            box-sizing border-box

            .span
                margin-left 40px
                display inline-block
                height 27px
                line-height 27px
                float left

            .input
                height 27px
                line-height 25px
                box-sizing border-box
                padding 0 2px
                margin-left 10px
                outline 0
                border 1px solid #d1d6de
                width 560px
                display inline-block

            .mask-bottom-button
                display inline-block
                float right
                font-size 13px
                line-height 25px
                width 75px
                border 1px solid #d1d6de
                text-align center
                margin-right 10px
                cursor pointer

    .files-expand
        display flex
        justify-content flex-end
        width 100%
        height 30px
        margin-bottom 11px
        .files-search-box
            position relative
            width 240px
            display flex
            justify-content space-between
            align-items center
            input
                display inline-block;
                width 100%;
                height 30px;
                line-height 1.5;
                padding 4px 7px;
                font-size 12px;
                border 1px solid #dcdee2;
                border-radius 4px;
                color #000;
                background-color #fff;
                background-image none;
                position relative;
                cursor text;
                text-indent 25px
                outline none
                transition border .2s ease-in-out,background .2s ease-in-out,box-shadow .2s ease-in-out,-webkit-box-shadow .2s ease-in-out;
                &::placeholder
                    color #9e9e9e
                &:focus
                    box-shadow 0 0 0 2px rgba(99,139,252,.2);
                    border-color #82a2fc;

            .file-search-icon
                position absolute
                outline none
                border none
                background-color #fff
                width 25px
                height 25px
                display flex
                justify-content center
                align-items center
                border-radius 2px
                left 4px
                cursor pointer

                >svg
                    width 20px
                    height 20px
                    stroke #424242
                &:hover
                    background-color #eeeeee
                &:active
                    background-color #e0e0e0
            .file-search-clean
                position absolute
                display flex
                justify-content center
                align-items center
                right 4px
                top 7px
                height 16px
                width 16px
                border-radius 50%
                background #aaa
                cursor pointer
                user-select none
                &:hover
                    background #666
                svg
                    width 8px
                    height 8px
                    stroke #fff
        .files-expand-add
            width 30px
            height 30px
            display flex
            align-items center
            justify-content center
            margin-left 10px
            cursor pointer
            user-select none
            &:hover
                background #e9e9e9
    .fileSelected-loading
        position absolute
        top 110px
        left 0
        width 100%
        height 453px
        display flex
        align-items center
        justify-content center
        background #fff
        &.other
            height 420px
            top: 80px;
        img
            width 300px
    .fileSelected-notTem
        position absolute
        top 110px
        left 0
        width 100%
        height 453px
        display flex
        align-items center
        justify-content center
    .fileSelected-newFile
        position absolute
        top 110px
        left 0
        width 100%
        height 453px
        display flex
        align-items center
        justify-content center
        img
            cursor pointer
            user-select none
        .fileSelected-text
            position absolute
            left 50%
            top 250px
            transform translateX(-50%)
            pointer-events none
    .fileSelected-modal
        .ivu-modal-footer
            border-top none
        .ivu-modal-body
            padding 0 24px 24px 24px !important
        .footer
            display flex
            justify-content flex-end
            margin-top 16px
            .btn
                width 72px
                height 28px
                text-align center
                line-height 28px
                border-radius 6px
                font-size 12px
                cursor pointer
                &:hover
                        opacity 0.8
            .ok-btn
                margin-right 16px
                background #017FFF
                color #fff
            .cancel-btn
                background #EBEDF1
                color #000
</style>

<template>
    <Modal class="fileSelected-modal" v-model="show" width="600" :title="title" footer-hide @on-cancel="doCancel()" @on-ok="doOk()">
        <div class="fileSelected-container">
            <div class="mask-content" :class="{ 'mask-content-symbol': isSymbolModal }">
                <div v-if="isSymbolModal" class="files-expand">
                    <div class="files-search-box">
                        <input
                            autocomplete="off"
                            spellcheck="false"
                            type="text"
                            :data-locate="'search-input'"
                            v-model="searchValue"
                            @keypress.enter="search()"
                        />
                        <button class="file-search-icon" @click="search()">
                            <iconSymbol :name="'fileSearchIcon'" />
                        </button>
                        <div class="file-search-clean" v-show="searchValue.length > 0" @click="cleanInput">
                            <iconSymbol :name="'importClose'" />
                        </div>
                    </div>
                    <div class="files-expand-add" @click="createNewFile">
                        <iconSymbol :style="{ width: '16px', height: '16px' }" :name="'addIcon'"></iconSymbol>
                    </div>
                </div>
                <div class="files-box">
                    <div class="folder-path-box" v-show="!searchMode">
                        <div class="folder-path">
                            <span style="font-weight: normal" @click="clickBreadcrumbs()">{{ $t("personal") }}</span>
                            <template v-for="(item, index) in path">
                                <Icon type="md-arrow-dropright"></Icon>
                                <span
                                    :style="{
                                        'font-weight': index === path.length - 1 ? 'bold' : 'normal',
                                    }"
                                    @click="clickBreadcrumbs(index)"
                                >
                                    {{ item }}
                                </span>
                            </template>
                        </div>
                    </div>
                    <div class="files-list">
                        <div class="file-item" v-for="item in folderList" @click="clickFolder(item)">
                            <div class="icon">
                                <img
                                    class="file-icon"
                                    src="@/home/assets/onlineview/folder.svg"
                                    alt=""
                                    style="vertical-align: middle; margin-right: 8px"
                                />
                            </div>
                            <div class="name">{{ item.name }}</div>
                        </div>
                        <div
                            class="file-item"
                            :class="{ selected: isActived(item) }"
                            v-for="item in filesList"
                            @click="clickFile(item)"
                            @dblclick="doOk()"
                        >
                            <div class="icon">
                                <img
                                    class="file-icon"
                                    name="eddxFileIcon"
                                    src="@/home/assets/onlineview/file.svg"
                                    alt=""
                                    style="vertical-align: middle; margin-right: 8px"
                                />
                            </div>
                            <div class="name">{{ item.name }}</div>
                            <div class="time">{{ toFileTime(item.lastModified) }}</div>
                            <div class="size">{{ toFileSize(item.size) }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <p style="padding-top: 16px; margin-top: 20px; border-top: 1px solid #e8e8e8" v-if="isSymbolModal">{{ $t("useSymbolTips") }}</p>
        </div>
        <div class="fileSelected-notTem" v-if="isNullCloud && !isSymbolModal">
            <p>{{ $t("notTem") }}</p>
        </div>
        <div class="fileSelected-loading" v-if="loading" :class="{ other: !isSymbolModal }">
            <img :src="require('@/home/assets/img/logoanimation.gif')" alt="" />
        </div>
        <div class="fileSelected-newFile" v-if="isNullCloud && isSymbolModal">
            <img src="@/home/assets/img/newFile.png" alt="" @click="createNewFile" />
            <p class="fileSelected-text">{{ $t("newFile") }}</p>
        </div>
        <div class="footer">
            <div class="ok-btn btn" @click="doOk">{{ $t("confirm") }}</div>
            <div class="cancel-btn btn" @click="doCancel">{{ $t("cancel") }}</div>
        </div>
    </Modal>
</template>

<i18n>
{
  "zh": {
    "importFile": "导入文件",
    "notTem": "此文件夹为空",
    "notFind": "没有找到相关文件",
    "noChosen": "您还没有选择文件！",
    "personal": "我的文件",
    "newFile": "新建文件",
    "useSymbolTips": "* 你需要选择一个文件或者新建文件来使用符号模板，这些符号将会显示在文件画布左侧的符号库中",
    "confirm": "确认",
    "cancel": "取消"
  },
  "en": {
    "importFile": "Import file",
    "notTem": "This folder is empty.",
    "notFind": "No related files found",
    "noChosen": "You have not selected a file yet!",
    "personal": "My Documents",
    "newFile": "New",
    "useSymbolTips": "* You need to select a file or create a new file to use the symbol template, these symbols will be displayed in the symbol libraries on the left side of the canvas.",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "importFile": "Importer un fichier",
    "notTem": "Ce dossier est vide",
    "notFind": "Aucun document connexe trouvé",
    "personal": "Cloud personnel",
    "noChosen": "Vous n'avez pas sélectionné de fichier!",
    "newFile": "Nouveau",
    "useSymbolTips": "* Vous devez sélectionner un fichier ou créer un nouveau fichier pour utiliser le modèle de symboles, ces symboles seront affichés dans les bibliothèques de symboles sur le côté gauche du canevas.",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "jp": {
    "importFile": "インポート",
    "notTem": "クラウドファイルはまだありません",
    "notFind": "関連ドキュメントは見つかりませんでした",
    "personal": "個人クラウド",
    "noChosen": "ファイルを選択していません",
    "newFile": "新規作成",
    "useSymbolTips": "* シンボルテンプレートを使用するには、ファイルを選択するか、新しいファイルを作成する必要があります。これらのシンボルは、キャンバスの左側にあるシンボルライブラリに表示されます。",
    "confirm": "確認",
    "cancel": "キャンセル"
  },
  "de": {
    "importFile": "Datei importieren",
    "notTem": "Dieser Ordner ist leer",
    "notFind": "Keine verwandten Dateien gefunden",
    "personal": "Persönlicher Cloud",
    "noChosen": "Sie haben noch keine Datei ausgewählt！",
    "newFile": "Neu erstellen",
    "useSymbolTips": "* Sie müssen eine Datei auswählen oder eine neue Datei erstellen, um die Symbolvorlage zu verwenden. Diese Symbole werden in den Symbolbibliotheken auf der linken Seite der Leinwand angezeigt.",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "es": {
    "importFile": "Importar archivo",
    "notTem": "Esta carpeta está vacía",
    "notFind": "No se encontraron archivos relacionados",
    "personal": "Nube Personal",
    "noChosen": "¡Aún no ha seleccionado un archivo!",
    "newFile": "Nuevo",
    "useSymbolTips": "* Necesita seleccionar un archivo o crear un nuevo archivo para usar la plantilla de símbolos, estos símbolos se mostrarán en las bibliotecas de símbolos en el lado izquierdo del lienzo.",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "pt": {
    "importFile": "Importar ficheiro",
    "notTem": "Esta pasta está vazia.",
    "notFind": "Não encontrados ficheiros relacionados",
    "personal": "Pessoal",
    "noChosen": "Ainda não selecionou um ficheiro!",
    "newFile": "Novo",
    "useSymbolTips": "* Você precisa selecionar um arquivo ou criar um novo arquivo para usar o modelo de símbolo, esses símbolos serão exibidos nas bibliotecas de símbolos no lado esquerdo da tela.",
    "confirm": "OK",
    "cancel": "Cancelar"
  },
  "it": {
    "importFile": "Importa file",
    "notTem": "Questa cartella è vuota.",
    "notFind": "Nessun file trovato",
    "personal": "Personali",
    "noChosen": "Nessun file selezionato!",
    "newFile": "Nuovo",
    "useSymbolTips": "* È necessario selezionare un file o creare un nuovo file per utilizzare il modello di simboli, questi simboli verranno visualizzati nelle librerie di simboli sul lato sinistro dell'area di disegno.",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "importFile": "導入檔案",
    "notTem": "此資料夾為空",
    "notFind": "沒有找到相關檔案",
    "personal": "個人雲端硬碟",
    "noChosen": "您還沒有選擇檔案！",
    "newFile": "新建",
    "useSymbolTips": "* 您需要選擇一個文件或創建一個新文件才能使用符號模板，這些符號將顯示在畫布左側的符號庫中",
    "confirm": "確認",
    "cancel": "取消"
  },
  "kr": {
    "importFile": "파일 가져오기",
    "notTem": "빈 폴더입니다",
    "notFind": "관련 파일이 없습니다.",
    "personal": "개인 클라우드",
    "noChosen": "파일을 선택하지 않았습니다!",
    "newFile": "새로 만들기",
    "useSymbolTips": "* 기호 템플릿을 사용하려면 파일을 선택하거나 새 파일을 만들어야 합니다. 이러한 기호는 캔버스 왼쪽의 기호 라이브러리에 표시됩니다.",
    "confirm": "확인 ",
    "cancel": "취소"
  },
  "id": {
    "importFile": "Impor file",
    "notTem": "Folder ini kosong.",
    "notFind": "File terkait tidak ditemukan",
    "noChosen": "Anda belum memilih file!",
    "personal": "Personal",
    "newFile": "Baru",
    "useSymbolTips": "* Anda perlu memilih file atau membuat file baru untuk menggunakan templat simbol, yang akan ditampilkan di pustaka simbol di sisi kiri kanvas.",
    "confirm": "OKE",
    "cancel": "Batalkan"
  }
}
</i18n>

<script>
    import { isEmpty } from "@/public/utils/tool";
    // import func from '../../../../vue-temp/vue-editor-bridge';
    export default {
        name: "fileSelector",
        data() {
            return {
                searching: false,
                loading: true,
                value: "",
                name: "",
                first: true,
                folderList: [],
                filesList: [],
                path: [],
                isGetFloder: false,
                searchValue: "",
                searchMode: false,
            };
        },
        props: ["title", "from"],
        computed: {
            // folderPath() {
            //     return this.$store.state.fileSystem.folderPath;
            // },
            // curData() {
            //     return this.$store.getters["fileSystem/curData"];
            // },
            show: {
                get() {
                    // if (this.$store.state.layout.fileSelected && this.first) {
                    //     // this.loadCloudData();
                    //     this.first = false;
                    // }
                    switch (this.from) {
                        case "symbol":
                            return this.$store.state.showFileSelector;
                        case "publish":
                            return this.$store.state.showPublishSelector;
                        default:
                            return this.$store.state.showGroupFileSelector;
                    }
                },
                set(v) {
                    let type;
                    switch (this.from) {
                        case "symbol":
                            type = "showFileSelector";
                            break;
                        case "publish":
                            type = "showPublishSelector";
                            break;
                        default:
                            type = "showGroupFileSelector";
                            break;
                    }
                    this.$store.commit("setState", {
                        type,
                        data: v,
                    });
                },
            },
            isSymbolModal() {
                return this.from == "symbol"; // 符号社区克隆模板弹窗
            },
            isNullCloud() {
                // 个人云文件是否为空
                return !this.loading && this.path.length == 0 && this.folderList.length == 0 && this.filesList.length == 0;
            },
        },
        methods: {
            isActived(item) {
                if (this.isPrivate) {
                    return item.info && item.info.file_key === this.value.file_key;
                } else {
                    return item.info && item.info.id === this.value.id;
                }
            },
            getFloder(prefix) {
                this.loading = true;
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.$store
                    .dispatch("getFloder", { prefix })
                    .then((res) => {
                        this.loading = false;
                        this.isGetFloder = false;
                        let folderList = res.data.data.folders || [];
                        let filesList = res.data.data.files || [];
                        folderList.map((item) => {
                            let list = item.prefix.split("/");
                            item.name = list[list.length - 2];
                        });
                        if (this.isPrivate) {
                            filesList.map((item) => {
                                item.name = item.info.name;
                            });
                        } else {
                            filesList.map((item) => {
                                let list = item.key.split("/");
                                let name = list[list.length - 1];
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                item.name = name;
                            });
                            filesList = filesList.filter((item) => {
                                if (item.key.match(/.+eddx$/)) {
                                    return true;
                                }
                                return false;
                            });
                        }
                        filesList.sort((a, b) => new Date(b.lastModified).getTime() - new Date(a.lastModified).getTime());
                        this.folderList = folderList;
                        this.filesList = filesList;
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                        // if (this.folderList.length == 0 && this.filesList.length == 0) {
                        //     (<any>this).$edMessage.success(this.$t("notTem"))
                        // }
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.isGetFloder = false;
                        this.$store.commit("setState", { data: false, type: "showLoading" });
                    });
            },
            // loadCloudData() {
            //     this.isLoadingCloud = true;
            //     this.$store
            //         .dispatch("fileSystem/setMyFileData")
            //         .then(() => {
            //             this.isLoadingCloud = false;
            //         })
            //         .catch(err => {
            //             this.isLoadingCloud = false;
            //         });
            // },
            toFileTime(time) {
                return new Date(time).toLocaleString();
            },
            toFileSize(limit) {
                var size = "";
                limit = Number(limit);
                if (limit < 1 * 1024) {
                    size = limit.toFixed(2) + "B";
                } else if (limit < 1 * 1024 * 1024) {
                    size = (limit / 1024).toFixed(2) + "KB";
                } else if (limit < 1 * 1024 * 1024 * 1024) {
                    size = (limit / (1024 * 1024)).toFixed(2) + "MB";
                } else {
                    size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
                }
                var sizeStr = size + "";
                var index = sizeStr.indexOf(".");
                var dou = sizeStr.substr(index + 1, 2);
                if (dou == "00") {
                    return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
                }
                return size;
            },
            clickBreadcrumbs(pathIndex) {
                if (this.isGetFloder) return;
                this.isGetFloder = true;
                this.value = "";
                if (pathIndex == void 0) pathIndex = 0;
                let prefix = "";
                this.path = this.path.slice(0, pathIndex);
                if (pathIndex) {
                    prefix = this.path.join("/") + "/";
                }
                this.getFloder(prefix);
                // this.$store.commit("fileSystem/updateFolderPath", folderPath);
                // if (folderPath == "personal") folderPath = "";
            },
            clickFolder(folder) {
                if (this.isGetFloder) return;
                this.isGetFloder = true;
                this.value = "";
                let list = folder.prefix.split("/");
                this.path.push(list[list.length - 2]);
                let prefix = this.path.join("/") + "/";
                this.getFloder(prefix);
                // let payload = {
                //     name: folder.folderPath.match(/\/?([^%#?&\/]+)\/$/)[1],
                //     path: folder.folderPath
                // };
                // this.$store.commit("fileSystem/toFolderPath", payload);
            },
            clickFile(file) {
                this.value = file.info || "";
            },
            search() {
                if (this.searching) return;
                this.searching = true;
                if (this.searchValue.trim() == "") {
                    this.getFloder("");
                    this.searching = false;
                    this.searchMode = false;
                    return;
                }
                this.$store
                    .dispatch("searchFile", { value: this.searchValue.trim() })
                    .then((res) => {
                        this.searching = false;
                        this.searchMode = true;

                        res.data.data.map((item) => {
                            if (this.isPrivate) {
                                item.name = item.info.name;
                            } else {
                                let filePath = [];
                                filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                                filePath = filePath.split("/");
                                let name = filePath.pop();
                                filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                                name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                                item.name = name;
                                item.filePath = filePath;
                            }
                        });
                        this.folderList = [];
                        this.filesList = res.data.data;
                        if (isEmpty(this.filesList)) {
                            this.$edMessage.error(this.$t("notFind"));
                        }
                    })
                    .catch((err) => {
                        this.searching = false;
                    });
            },
            cleanInput() {
                this.searchValue = "";
                this.searchMode = false;
                this.getFloder("");
            },
            createNewFile() {
                this.$emit("createNewFile");
                this.value = "";
                this.show = false;
                this.searchValue = "";
                this.searchMode = false;
            },
            doCancel() {
                this.$emit("on-cancel", this.value);
                this.value = "";
                this.show = false;
                this.searchValue = "";
                this.searchMode = false;
                this.$store.commit("setState", { data: false, type: "showLoading" });
            },
            doOk() {
                console.log("doOk");
                this.show = false;
                if (!this.value) {
                    this.$edMessage.error({ content: this.$t("noChosen") });
                    this.$emit("on-error");
                    return;
                }
                this.$emit("on-ok", this.value);
                this.value = "";
                this.show = false;
                this.searchValue = "";
                this.searchMode = false;
            },
        },
        watch: {
            show: function (val) {
                if (val) {
                    (this.path = []), this.getFloder("");
                    console.log("val123", val);
                    setTimeout(() => {
                        document.querySelector(".files-box .files-list").scrollTo({ top: 0 });
                    }, 100);
                }
            },
        },
        mounted() {
            // this.getFloder("");
            console.log("mounted");
        },
    };
</script>
